import type { ProductPrices } from 'product/types/Prices'
import type { ProductColor } from 'product/types/Product'

export const mapProductPricesToEEC = (
	prices: Record<string, ProductPrices> | undefined,
	colorId: ProductColor['id']
) => ({
	currentPrice: prices?.[colorId]?.price ?? 0,
	originalPrice:
		prices?.[colorId]?.previousPrices?.originalShop ??
		prices?.[colorId]?.price ??
		0,
})
